import { render, staticRenderFns } from "./R2_grip.vue?vue&type=template&id=0d6627b2&scoped=true"
import script from "./R2_grip.vue?vue&type=script&lang=js"
export * from "./R2_grip.vue?vue&type=script&lang=js"
import style0 from "./R2_grip.vue?vue&type=style&index=0&id=0d6627b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6627b2",
  null
  
)

export default component.exports